export const formLabels = {
  title: 'PACS to PACS Image Transfer Request Form',
  subtitle:
    'Please complete the following form to request PACS to PACS transfers of images.'
}

export const referrerLabels = {
  firstName: 'First name of referrer/requestor',
  lastName: 'Last name of referrer/requestor',
  providerNumber: 'Provider number',
  emailAddress: 'Email address',
  phoneNumber: 'Phone number'
}

export const requestLabels = {
  firstName: 'First name of patient',
  lastName: 'Last name of patient',
  dob: 'Patient date of birth',
  requestingInstitution: 'Study to be sent to',
  useInteleViewer: 'Supply access to images on my InteleViewer/ApexConnect account',
  useWachs: 'Study to be sent to WACHS (WAPACS)',
  inteleViewerUsername: 'InteleViewer username',
  modality: 'Request modality',
  studyDescription: 'Request study description',
  businessUnit: 'Source business unit',
  urgent: 'Urgent request',
  startDate: 'Study date start',
  endDate: 'Study date end'
}
